/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: forms.js
 */

// legacy
$.namespace('SCSC');
$.namespace('SCSC.forms');

SCSC.forms.isPlaceholderSupported = function() {
	var input = document.createElement("input");
	return ('placeholder' in input);
};

SCSC.forms.placeholderSupported = SCSC.forms.isPlaceholderSupported();

/**
 * Placeholder for form fields
 */
// used by SCS.supportstrip.init
SCSC.forms.placeholder = function() {
	var placeholderFieldFocussed = function () {
		var $this = $(this);
		if ($this.hasClass('placeholder')) {
			$this.removeClass('placeholder');
			if (!SCSC.forms.placeholderSupported && $this.val() == $this.attr('placeholder')) {
				$this.val('');
			}
		}
	};
	var placeholderFieldBlurred = function () {
		var $this = $(this);
		if ($this.val() == '') {
			if (!SCSC.forms.placeholderSupported) {
				$this.val($this.attr('placeholder'));
			}
			$this.addClass('placeholder');
		}
	};
	var getUninitialized = function () {
		return !$(this).data('placeholderInitialized');
	};
	$('.scs-form').find('input[placeholder][placeholder!=""], textarea[placeholder][placeholder!=""]').filter(getUninitialized)
		.focus(placeholderFieldFocussed)
		.blur(placeholderFieldBlurred).trigger('blur')
		.change(function () { // is called by UI when field is not focussed (eg. datefield)
			var $this = $(this);
			if (!$this.data('isChanging')) {
				$this.data('isChanging', true);
				placeholderFieldFocussed.call(this);
				placeholderFieldBlurred.call(this);
				$this.data('isChanging', false);
			}
		})
		.data('placeholderInitialized', true);

	$('form').filter(getUninitialized)

		// Adserver 21,22 - Order-Tracking - Form-Tracking - Item #3374
		// quick and dirty for old forms
		.each(function() {
			// write success URL to data attribute
			var $form = $(this),
				$scsForm = $form.find('.scs-form'),
				redirectUrl = $form.find('input[type="hidden"][name=":redirect"]').val() || '';

			if ($scsForm.length) {
				if (redirectUrl.length) {
					$scsForm.data('success-url', redirectUrl);
					debug.log('Form-Tracking: using form :redirect', $scsForm.data('success-url'));
				} else {
					$scsForm.data('success-url', $form.attr('action'));
					debug.log('Form-Tracking: using form action', $scsForm.data('success-url'));
				}
			}
		})
		.submit(function() {
			var $form = $(this);
			$form.find('.placeholder').each(function() {
				placeholderFieldFocussed.call(this);
			});

			// Adserver 21,22 - Order-Tracking - Form-Tracking - Item #3374
			// quick and dirty for old forms
			// raise success event
			$form.find('.scs-form').trigger('formsuccess');

		})
		.data('placeholderInitialized', true);
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/forms_scsc.js
// module id = 83
// module chunks = 0